/**
 * 远景飞鸟(方案 C6):低频氛围件,填画面上层构图。
 * 每 35~80s 一群(4~6 只)自一侧掠过,V 形双翼两段二次贝塞尔,扑翼 sin 驱动;
 * 颜色 = 剪影色向天色折半(远景空气透视),alpha 0.55。不抢戏,只证明世界活着。
 */
import { Graphics } from 'pixi.js';
import { Stage, LW, LH } from '../engine/Stage';
import { sky } from '../engine/SkyRenderer';
import { mix } from '../engine/Palette';
import { rand } from '../engine/util';

interface Bird { ox: number; oy: number; ph: number; s: number }

export class Birds {
  private g = new Graphics();
  private t = 0;
  private next = rand(12, 30);   // 首群稍早,让首访也可能遇见
  private flying = false;
  private dir = 1;
  private x = 0;
  private y = 0;
  private spd = 46;
  private birds: Bird[] = [];

  constructor(stage: Stage) {
    stage.layers.islandFar.addChild(this.g);
  }

  update(dt: number) {
    this.t += dt;
    if (!this.flying) {
      this.next -= dt;
      if (this.next <= 0) this.launch();
      else return;
    }
    this.x += this.dir * this.spd * dt;
    const gone = this.dir > 0 ? this.x > LW + 80 : this.x < -80;
    if (gone) { this.flying = false; this.g.clear(); this.next = rand(35, 80); return; }

    const c = mix(sky.silhouette, sky.state.top, 0.45);
    const g = this.g; g.clear();
    for (const b of this.birds) {
      const bx = this.x + b.ox * this.dir, by = this.y + b.oy + Math.sin(this.t * 1.1 + b.ph) * 3;
      // 翼展 13(首验 7px 经世界缩放只剩 3 屏幕像素,完全不可见)
      const flap = Math.abs(Math.sin(this.t * 5.2 + b.ph)) * 7 + 2.5;   // 翼尖抬角
      const w = 13 * b.s;                                               // 半翼展
      g.moveTo(bx - w, by - flap * b.s);
      g.quadraticCurveTo(bx - w * 0.35, by + 2, bx, by);
      g.quadraticCurveTo(bx + w * 0.35, by + 2, bx + w, by - flap * b.s);
      g.stroke({ width: 2.2 * b.s, color: c, alpha: 0.6 });
    }
  }

  private launch() {
    this.flying = true;
    this.dir = Math.random() < 0.5 ? 1 : -1;
    this.x = this.dir > 0 ? -60 : LW + 60;
    this.y = LH * rand(0.14, 0.3);
    this.spd = rand(40, 56);
    this.birds = [];
    const n = 4 + Math.floor(rand(0, 3));
    for (let i = 0; i < n; i++) {
      // 松散雁阵:沿飞行反方向逐个错位,带随机抖散
      this.birds.push({ ox: -i * rand(26, 40), oy: (i % 2 ? 1 : -1) * i * rand(5, 10), ph: rand(0, 6.28), s: rand(0.8, 1.15) });
    }
  }
}
